import { Country } from './../model/country.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
  providedIn: 'root'
})
export class PostalAddressService extends BaseRestApiService {
  constructor(
    http: HttpClient,
    urlProvider: UrlProviderService
  ) {
    super(http, urlProvider);
  }

  searchCities(
    searchString: string,
    countryId: number,
    stateId: number
  ): Observable<any> {
    return this.post<any>(EndPoints.postalAddress_searchCities, false, '', {
      searchString: searchString,
      countryId: countryId,
      stateId: stateId
    });
  }

  searchCitiesById(
    id: number
  ): Observable<any> {
    return this.get<any>(EndPoints.postalAddress_searchCitiesById, false, id);
  }

  searchStates(
    searchString: string,
    countryId: number,
  ): Observable<any> {
    return this.post<any>(EndPoints.postalAddress_searchStates, false, '', {
      searchString: searchString,
      countryId: countryId
    });
  }

  searchStatesById(
    id: number
  ): Observable<any> {
    return this.get<any>(EndPoints.postalAddress_searchStatesById, false, id);
  }

  searchCountries(
    searchString: string
  ): Observable<any> {
    return this.post<any>(EndPoints.postalAddress_searchCountries, false, '', {
      searchString: searchString
    });
  }

  searchCountriesById(
    id: number
  ): Observable<any> {
    return this.get<any>(EndPoints.postalAddress_searchCountriesById, false, id);
  }

  searchZipcodes(
    searchString: string,
    searchCountry: Country,
    stateId: number
  ): Observable<any> {
    return this.post<any>(EndPoints.postalAddress_searchZipcodes, false, '', {
      searchString: searchString,
      searchCountry: searchCountry,
      stateId: stateId
    });
  }

  searchZipcodesById(
    id: number
  ): Observable<any> {
    return this.get<any>(EndPoints.postalAddress_searchZipcodesById, false, id);
  }
}
